import fileSaver from 'file-saver';
import {
  ADD_USERINSTRUCTION_TYPE,
  CLEAR_USERINSTRUCTION_TYPE,
  USER_DETAILS_DATA,
  GET_ALL_DETAILS_TABS,
  CLEAR_USERINSTRUCTION_TAB_TYPE,
  GET_USER_INSTRUCTION_CARE_GROUP,
  GET_GROUP_USER_INSTRUCTION_DETAILS,
  USER_DETAILS_GROUP_DATA,
  CHECK_UNIQUE_PRODUCT_TYPE,
  GET_CARE_LIBRARIES,
  GET_ALL_COLUMNS,
} from './UserInstruction.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { ERROR_MESSAGE } from '../../../../Components/helper';
import * as CareLabelService from '../../../../services/care-label.service';

export const clearTabReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: CLEAR_USERINSTRUCTION_TYPE,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const fetchUserInstructionAction = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await CareLabelService.fetchUserInstruction(params);
    if (res?.code === 200) {
      await dispatch({
        type: ADD_USERINSTRUCTION_TYPE,
        payload: {
          ...params,
          data: res?.data,
        },
      });
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const addUserInstructionAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.addUserInstruction(data);
    if (res && res.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUserInstructionAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.UpdateUserInstruction(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else if (transactionMsg(res?.data?.errMsg)) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (transactionMsg(res?.message)) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMultipleUserInstructionAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteMultipleUserInstruction(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETED_SUCCESSFULY_MESSAGE'), 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchColumnDetailList = (params) => async (dispatch) => {
  try {
    const res = await CareLabelService.fetchUserColumnDetail(params);
    if (res.code === 200) {
      await dispatch({
        type: USER_DETAILS_DATA,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res?.data?.errMsg, 'danger');

    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUpdateColumnDetailList = (_id, params, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.addUpdateColumnsDetailService(params, _id);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res?.message), 'success');
    } else {
      toasterMsg(transactionMsg(`${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (err) {
    console.error('addColumnsToPim..', err);
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllUserTabs = (userId, params) => async (dispatch) => {
  try {
    const res = await CareLabelService.getUserTabs(userId, params);
    if (res?.code === 200) {
      await dispatch({
        type: GET_ALL_DETAILS_TABS,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res?.data?.errMsg, 'danger');

    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadCareLibrary = (data, t) => async () => {
  try {
    const res = await CareLabelService.exportExcelService(data);
    if (res) {
      if (data?.type) {
        fileSaver.saveAs(res, `Sample Care User ${data?.tabName} Label Library`);
      } else {
        fileSaver.saveAs(res, `Care User ${data?.tabName} Label Library`);
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const importCareUserLib = (params, t) => async () => {
  try {
    const response = await CareLabelService.importCareUserExcelSheet(params);
    if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(t(`BOM_LIBRARY_VIEW.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(t(`BOM_LIBRARY_VIEW.${response.message}`), 'danger');
    } else {
      toasterMsg(t(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const clearTabDetailsReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: CLEAR_USERINSTRUCTION_TAB_TYPE,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const deleteColumns = (id, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteColumnService(id);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.CARE_USER_COLUMN_DELETED_SUCCESSFULY'), 'success');
    } else {
      toasterMsg(transactionMsg(`USER_INSTRUCTION_LIBRARY.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const updateSequenceUserInstructionAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.updateSequenceUserInstruction(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`USER_INSTRUCTION_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (transactionMsg(res?.data?.errMsg)) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (transactionMsg(res?.message)) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUpdateUserInstructionDetailAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.addUpdateUserInstructionDetail(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else if (transactionMsg(res?.data?.errMsg)) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

const BLOCKED_DELETE_ERROR_KEYS = [
  'modules/care-user-instructions:ROW_IN_USE_BY_PRODUCT',
  'modules/care-user-instructions:ROW_ACTIVE_IN_GROUP',
];

export const deleteUserInstructionDetailAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteUserInstructionDetail(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETED_SUCCESSFULY_MESSAGE'), 'success');
      return { success: true };
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return {
      success: false,
      blocked: BLOCKED_DELETE_ERROR_KEYS.includes(res?.data?.errMsg),
      errMsg: res?.data?.errMsg,
    };
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return { success: false, blocked: false, errMsg: err.toString() };
  }
};

export const deactivateRowInGroupAction = (groupId, rowId, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deactivateRowInGroupService(groupId, rowId);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DEACTIVATED_SUCCESSFULY_MESSAGE'), 'success');
      return { success: true };
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return { success: false, errMsg: res?.data?.errMsg };
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return { success: false, errMsg: err.toString() };
  }
};

export const fetchUserInstructionCareGroupAction = (params) => async (dispatch) => {
  try {
    const res = await CareLabelService.getUserInstructionCareGroup(params);
    if (res?.code === 200) {
      await dispatch({
        type: GET_USER_INSTRUCTION_CARE_GROUP,
        payload: res?.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.errMsg, 'danger');
  }
};

export const deleteMultipleGroupAction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteMultipleGroupService(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETED_SUCCESSFULY_MESSAGE'), 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchGroupUserInstructionsDetailsAction = (params) => async (dispatch) => {
  try {
    const res = await CareLabelService.getGroupUserInstructionsDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: GET_GROUP_USER_INSTRUCTION_DETAILS,
        payload: res?.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.errMsg, 'danger');
  }
};

export const fetchColumnDetailGroupList = (params) => async (dispatch) => {
  try {
    const res = await CareLabelService.fetchUserColumnDetail(params);
    if (res.code === 200) {
      await dispatch({
        type: USER_DETAILS_GROUP_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveCareUserGroup = (payload, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.saveCareUserGroupService(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SAVED_SUCCESSFULLY_MESSAGE');
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(transactionMsg(res.data?.errMsg), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const checkUniqueProductType =
  (isRequired = false) =>
  async (dispatch) => {
    try {
      const res = await CareLabelService.checkUniqueProductType(isRequired);
      if (res?.code === 200) {
        await dispatch({
          type: CHECK_UNIQUE_PRODUCT_TYPE,
          payload: res?.data,
        });
        return true;
      }
    } catch (err) {
      toasterMsg(err.toString(), 'danger');
    }
  };

export const getCareLibraries = () => async (dispatch) => {
  try {
    const res = await CareLabelService.getCareLibraries();
    if (res?.code === 200) {
      await dispatch({
        type: GET_CARE_LIBRARIES,
        payload: res?.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllColumns = () => async (dispatch) => {
  try {
    const res = await CareLabelService.getAllColumns();
    if (res?.code === 200) {
      await dispatch({
        type: GET_ALL_COLUMNS,
        payload: res?.data,
      });
      return true;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const refreshTabs = (id, transactionMsg) => async (dispatch) => {
  try {
    const res = await CareLabelService.refreshTabs(id);
    if (res?.code === 200) {
      await dispatch({
        type: GET_GROUP_USER_INSTRUCTION_DETAILS,
        payload: res?.data,
      });
      toasterMsg(transactionMsg('modules/care-user-instructions:TABS_REFRESH_SUCCESSFULLY'), 'success');
      return true;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
